export default [
    {
        name: 'Location Tool',
        icon: 'fas fa-map-marked-alt',
        description: `Move the pointer to get the longitude & latitude of the pointer location. Click on map to copy the coordinates to clipboard.`,
        mode: 'simple_select',
    },
    {
        name: 'Zoom to Location',
        icon: 'fas fa-search-location',
        description:
            'Input coordinates and click on zoom to, to zoom to the location.',
        mode: 'simple_select',
    },
    {
        name: 'Line Elevation',
        icon: 'fas fa-chart-line',
        description:
            'Select a line record to display its elevation profile as a graph chart.',
        mode: 'simple_select',
    },
];
